/* eslint-disable max-len */
export default {
  cfmoto: {
    AIReview: "Révision de l'IA",
    AIReviewFailed: "La révision de l'IA a échoué",
    AIReviewPassed: "La révision de l'IA a réussi",
    AIReviewStatus: "Statut de révision de l'IA",
    AIReviewing: "La révision de l'IA est en cours de révision",
    America: 'Etats-Unis',
    CheckSupportInstall: 'Vérifiez si les modifications sont prises en charge',
    ImporterCommunityDisplayName: "Nom d'affichage de la communauté d'importateur",
    ImporterContactEmail: "E-mail de contact de l'importateur",
    IndicatorLight: 'voyant lumineux',
    Instruction: 'Avis',
    MostPicture4OrVideo: '(Maximum 4 photos / 1 vidéo)',
    PleaseContactPersonnelCommunicating: 'Veuillez contacter le personnel de CFMOTO pour communiquer',
    Redemptionservice: 'Service disponible dans la consommation',
    USD: 'USD',
    UnbindingApplicationCommitment: "Demande d'engagement de déliaison",
    aboutAccount: 'À propos du compte',
    aboutVehicle: 'À propos du véhicule',
    accountApplyRejected: 'Demande de suppression de compte rejetée',
    accountCancel: 'Demande de suppression de compte',
    accountDeletExplain: 'Instructions de suppression de compte',
    accountDelete: 'Suppression de compte',
    accountDeleted: 'Compte supprimé',
    accountFormatError: 'Format de compte incorrect/utilisateur inexistant. Veuillez adapter la rédaction correspondante en fonction de la cause réelle',
    accountNumber: 'Numéro de compte',
    action: 'Opération',
    actionFail: "l'opération a échoué",
    actionSuccess: 'Opération avec succès',
    activeScore: 'Notation active',
    activeTrigger: "Les utilisateurs déclenchent activement (À propos de l'application : accédez à l'évaluation)",
    activity: 'Activités',
    activityCancel: "Annulation d'événement",
    activityCover: "Couverture de l'activité",
    activityDetails: "Détails de l'activité",
    activityId: "ID d'activité",
    activityList: 'Liste des activités',
    activityManagement: "Gestion de l'activité",
    activitySearch: "Recherche de l'activité",
    activityTime: "Heure de l'activité",
    activityTitle: "Titre de l'activité",
    activityVenue: "Lieu de l'activité",
    adaptable: 'Pour',
    add: 'Ajouter',
    addAccountDeletExplain: 'Ajouter un avis de suppression de compte',
    addAuthenticationTime: "Ajouter le temps d'authentification",
    addCanadaPrivacyPolicy: 'Ajouter la politique de confidentialité du Canada',
    addCanadaTelematicsPolicy: "Ajouter l'Accord télématique canadien",
    addCanadaUserPolicy: "Ajouter un contrat d'utilisation canadien",
    addDashcamHelp: 'Aide Dashcam ajoutée',
    addDataDeletExplain: 'Ajouter un avis de suppression de données',
    addEmail: 'Nouveau courriel',
    addExhibitionCategory: 'Ajouter une catégorie de boutique',
    addExhibitionSeries: 'Ajouter une Nouvelle Série',
    addHelpConfiguration: 'Ajouter aide pour expliquer la configuration',
    addInformationCategory: "Ajouter une nouvelle catégorie d'informations",
    addInformationContent: "Ajouter un nouveau contenu d'information",
    addKolUserAuthentication: "Ajouter l'authentification de l'utilisateur KOL",
    addPicture: 'Ajouter une image',
    addPrivacyAgreement: 'Nouveau Protocole de confidentialité',
    addPrivacySubmitSure: "La date d'entrée en vigueur et la description des modifications de la nouvelle politique de confidentialité ne peuvent pas être ajustées après la soumission. Confirmez la soumission.",
    addPushConfiguration: 'Ajouter une configuration de poussée',
    addQuestion: 'Ajouter une question',
    addSdkStaement: 'Ajouter la déclaration du SDK',
    addServiceIntroduce: 'Introduction de nouveaux services',
    addShowroomModel: 'Ajouter un modèle de showroom',
    addThisUser: 'Ajouter cet utilisateur',
    addTopic: 'Ajouter un sujet',
    addUser: "Ajouter l'utilisateur",
    addUserAgreement: 'Ajouter un protocole utilisateur',
    addUserRole: "Ajouter un rôle d'utilisateur",
    addVehicleModel: 'Nouveaux modèles',
    addVehicleModelCategory: 'Ajouter une catégorie de modèle',
    addVideo: 'Ajouter une vidéo',
    addedBy: 'Ajouté par',
    additionalFeedback: 'Commentaires supplémentaires',
    administratorUnbind: "Débridage par l'administrateur",
    afternoon: 'Après-midi',
    agreeServiceAgreement: "En activant le service, vous êtes réputé(e) avoir accepté l'Accord de service",
    agreeSignOut: 'Accepter pour terminer',
    agreementContent: 'Accord',
    all: 'Tout',
    allArea: 'Pays/région cible',
    allComment: 'Tous les commentaires',
    allImportSuccess: 'Importation terminée. Tous importés avec succès',
    allServicesSimultaneously: 'Tous les services',
    allUser: 'Tous les utilisateurs',
    allVehicleModel: 'Tous les modèles',
    alreadyOver: 'Tout ici',
    ambientLightControl: 'Contrôle de la lumière ambiante',
    amount: 'Montant',
    android: 'Android',
    answer: 'Répondre',
    answerOta1:
      "OTA signifie que le véhicule télécharge le dernier logiciel de micrologiciel à partir du cloud via le réseau cellulaire, et vous pouvez mettre à niveau le véhicule en ligne via CFMOTO RIDE pour optimiser en permanence l'expérience de conduite",
    answerOta2:
      "Lorsqu'une nouvelle version de l'écran TFT peut être mise à niveau, vous recevrez la notification de mise à niveau. Si %s est affiché en bas de la page actuelle, cela signifie que l'écran TFT du véhicule n'a pas besoin d'être mis à niveau.",
    answerOta3: "Vous pouvez cliquer sur %s dans le coin supérieur droit pour en savoir plus sur les instructions de fonctionnement de l'OTA à l'avance.",
    anyCar: 'Y a-t-il une voiture ?',
    appMessagePushCountLimit: "La limite de notifications pour ce mois-ci (2 fois/mois) est atteinte. Le contenu modifié peut être enregistré comme brouillon. Voulez-vous l'enregistrer ?",
    appPush: "Notification d'application",
    appRating: 'Gestion du mécanisme de notation',
    appType: 'Système téléphonique',
    appVersion: "Version de l'application",
    applicableCountry: 'Pays applicables',
    applicableCountryName: 'Pays applicables',
    applyTime: 'Heure de la demande',
    applyUnbinding: 'Appliquer la déliaison',
    appointmentReleaseTime: 'Heure de sortie du rendez-vous',
    approval: 'Approbation',
    arrivalNumberDescription: "nombre d'appareils ayant reçu la notification",
    arrivalNumberDescription0: "Le nombre réel d'arrivées au terminal du périphérique après l'envoi du message de notification (les arrivées après 5 jours ne seront pas comptabilisées)",
    arrivalNumberVolume: "Nombre d'arrivées",
    askAllowUserSpeakInCommunity: "Autoriser l'utilisateur banni à publier des posts dans la communauté ",
    askApproveIt: "L'approuver",
    askDeleteCategory: "S'il faut supprimer cette catégorie",
    askDeleteInformactionCategory: "S'il faut supprimer cette catégorie d'informations",
    askDeleteInformationContent: "S'il faut supprimer le contenu des informations",
    askDeleteKolUserAuthentication: "Êtes-vous sûr(e) de vouloir supprimer cette authentification de l'utilisateur KOL ?",
    askDeleteOfficialAuth: "Êtes-vous sûr(e) de vouloir supprimer l'authentification officielle de ce compte ?",
    askDeleteQuestion: 'Voulez-vous supprimer cette question',
    askDeleteThisActivity: 'Supprimer cette activité ',
    askDeleteThisBanner: 'Supprimer ce Banner',
    askDeleteThisComment: 'Êtes-vous sûr de vouloir supprimer ce commentaire',
    askDeleteThisPost: 'Supprimer ce post ',
    askDeleteThisTopic: 'Supprimer ce sujet',
    askDeleteVehicleType: 'Confirmer supprimer le modèle',
    askDeleteVehicleTypeCategory: "S'il faut supprimer cette catégorie de modèle",
    askDeleteVehicleTypeDetails: "S'il faut supprimer les détails du modèle de voiture",
    askDeleteVehicleTypeSeries: "S'il faut supprimer cette série de modèles",
    askLogout: 'Êtes-vous sûr de vouloir quitter le système ?',
    askNotApproveIt: "Ne pas l'approuver",
    askSaveSettings: "Les paramètres n'ont pas encore été enregistrés, voulez-vous les enregistrer ?",
    associatedPostNumber: 'Nombre de posts associés',
    associatedPosts: 'Posts associés',
    associatedVehicle: 'véhicule associé',
    assoclatedContent: 'Contenu associé',
    atmosphereCContent: "Les paramètres n'ont pas encore été enregistrés, voulez-vous les enregistrer ?",
    atmosphereContent1Msg1:
      "Une fois la fonction activée, le téléphone mobile allume le Bluetooth et l'application continue de fonctionner. Lorsque vous approchez du véhicule de loin en près, le véhicule peut être automatiquement déverrouillé et mis sous tension.",
    atmosphereContent1Msg2: "S'il n'est pas normalement déverrouillé et mis sous tension, appuyez sur le bouton d'alimentation du véhicule pour le déverrouiller et le mettre sous tension",
    atmosphereContent1Msg3: "Le déverrouillage automatique de proximité ne sera déclenché qu'une seule fois avant la déconnexion Bluetooth",
    atmosphereContent2Msg1: 'Após a função ser ligada, o veículo desligará automaticamente após 5 segundos após as três condições do veículo serem desligadas, a velocidade do veículo é 0 e O templo caiu',
    atmosphereContent2Msg2: 'Iniciar o veículo durante o período de desligamento automático, a velocidade do veículo não é 0 ou a têmpora é colocada cancelará o desligamento automático …',
    atmosphereContent3Msg1:
      "Une fois la fonction activée, lorsque le véhicule est éteint, le téléphone mobile allume le Bluetooth et l'application continue de fonctionner ou porte la clé physique. Lorsque vous approchez du véhicule de loin en près, les feux du véhicule clignotent pour accueillir les invités",
    atmosphereContent3Msg2: "Afin d'éviter que des déclenchements fréquents ne provoquent une perte de puissance du véhicule, après le déclenchement de la fonction d'accueil deux fois dans les 30 secondes, elle ne reprendra que 30 minutes plus tard",
    atmosphereContent4Msg1: "Une fois la fonction activée, les feux de croisement et de loin s'allument automatiquement pendant 10 secondes après la mise hors tension du véhicule.",
    atmosphereIntroduce1: 'Instructions de déverrouillage quasi automatique',
    atmosphereIntroduce2: 'instructions de mise hors tension automatique',
    atmosphereIntroduce3: 'Instructions de réveil automatique',
    atmosphereIntroduce4: 'Lumières retardées',
    atmosphereSetINfo: 'Les nouveaux paramètres prendront effet dans les 1 à 3 minutes après la mise sous tension du véhicule, veuillez vous assurer que le véhicule est dans une bonne position de signal',
    auditStatus: 'État de la révision',
    authType: "Type d'identification",
    authenticatedName: 'Nom authentifié',
    avatar: 'Photo prof.',
    backApply: 'retirer sa candidature',
    backApplySuccess: 'retrait de la candidature réussi',
    backHome: "Retour à la page d'accueil",
    bannerDisplayImages: 'Image de bannière',
    bannerList: 'Liste du Banner',
    bannerManagement: 'Gestion du Banner',
    bannerPictrure: 'Dessin du Banner',
    bannerSearch: 'Recherche du Banner',
    bannerTitle: 'Titre Banner',
    baseService: 'Standard Edition\n',
    baseServicePay: 'Paiement pour les Standard Edition',
    baseServiceResetTimeRule: "L'heure de réinitialisation du service de base ne peut pas être postérieure à l'heure actuelle",
    batchImport: 'Importation par lots',
    batchUser: 'Utilisateurs par lots',
    beijingTime: 'Heure UTC+8',
    belogCategory: 'catégorie',
    belongCategory: 'Catégorie associée',
    bindDevice: 'Dispositif de liaison',
    bindEmail: "Lier l'e-mail",
    bindVehicle: 'Lier le véhicule',
    bindingStatus: 'Statut de liaison',
    bindingText1: '1.\tServices télématiques',
    bindingText10: "1.1.2.\tFournir une planification d'itinéraire pendant la navigation, y compris le calcul de la distance entre les véhicules et la navigation à pied dans le but de trouver un véhicule .",
    bindingText11: '1.2.\tEnvoi des notifications nécessaires au Client en fonction des conditions du véhicule.',
    bindingText12:
      "1.2.1.\tCFMOTO mettra fin aux notifications du client sur l'entretien du véhicule (par exemple, en fonction de la distance totale parcourue par le client, de l'heure à laquelle le client achète le véhicule, des exigences de temps ou de distance de conduite pour l'entretien du véhicule) .",
    bindingText13:
      "1.2.2.\tSur la base des données du véhicule , CFMOTO enverra au Client des notifications de situation anormale ; y compris l'analyse des données par OEM (selon le modèle) pour fournir un service client et un suivi de l'optimisation du véhicule .",
    bindingText14: "1.3.\tAssistance dans l'analyse de la cause de l'accident si le Client signale un accident grave du Véhicule.",
    bindingText15:
      "1.3.1.\tEn cas d'accident grave du Véhicule, tel que lorsque le Véhicule se renverse ou se renverse sur le côté pendant la conduite, CFMOTO assistera le Client sur demande pour clarifier si l'accident est dû à un défaut du Véhicule ou à d'autres circonstances. La demande doit être soumise à CFMOTO par le Client via le distributeur/partenaire commercial local indiqué dans le Contrat de Vente de Véhicule.",
    bindingText16: "1.3.2.\tDans la mesure où les données disponibles le permettent, CFMOTO évaluera les données par rapport à la cause de l'accident et fournira au Client un rapport correspondant.",
    bindingText17: '1.4.\tAssistance au Client pour récupérer le Véhicule après la perte du Véhicule .',
    bindingText18:
      "1.4.1.\tSi le Véhicule est perdu, CFMOTO fournira au Client les données de localisation du Véhicule et d'autres données utiles sur l'état du Véhicule (telles que l'emplacement de la dernière activation, l'état actuel du véhicule, etc.) sur demande et si disponibles.",
    bindingText19: '1.4.2.\tLa demande doit être soumise à CFMOTO par le Client via le distributeur/partenaire commercial local indiqué dans le Contrat de Vente de Véhicule.',
    bindingText2:
      'CFMOTO Powersports, Inc. (ci-après dénommé « CFMOTO » ) fournit des services télématiques de véhicule au client qui a acheté le véhicule CFMOTO (ci-après dénommé « Client » ). Pour ces services, CFMOTO utilise des données enregistrées par le Véhicule concernant le Véhicule et son comportement de conduite dans la période concernée. Dans le détail, cela concerne les données suivantes :',
    bindingText20: '1.5.\tSignalement des problèmes après-vente .',
    bindingText21: "1.5.1.\tCFMOTO collecte à distance les notifications de code d'erreur envoyées par le Véhicule en cas de dysfonctionnement de ses composants et fournit les informations respectives à la demande du Client directement au Client.",
    bindingText22: '1.5.2.\tLa demande doit être soumise à CFMOTO par le Client via le distributeur/partenaire commercial local indiqué dans le Contrat de Vente de Véhicule.',
    bindingText23: '2.\tRestrictions et exclusions de service',
    bindingText24:
      '2.1.\tIl est expressément précisé que des modifications structurelles ou autres modifications techniques du Véhicule peuvent limiter la fourniture des services ou même la rendre impossible, puisque les services dépendent de la fourniture correcte des données du véhicule.',
    bindingText25: '2.2.\tLorsque ces services ne peuvent pas être fournis en raison de la performance des données de tiers ou des réseaux de télécommunication, toute responsabilité de CFMOTO est exclue.',
    bindingText26: '3.\tConfidentialité',
    bindingText27:
      'CFMOTO respectera les réglementations applicables en matière de protection des données lors du traitement des données personnelles en rapport avec le véhicule CFMOTO . Les termes de la politique de confidentialité de C FMOTO sont définis dans cette APPLICATION CFMOTO RIDE . En complément de la politique de confidentialité , cette notice est conforme à la politique de confidentialité . Et le Client peut se référer à la politique de confidentialité pour certains contenus liés au traitement des données non couverts par la présente notice.',
    bindingText28: '4.\tService Clients',
    bindingText29:
      "4.1.\tLe client peut se sentir libre d'envoyer des questions, commentaires ou préoccupations liés à la confidentialité à CFMOTORIDEAPP@cfmotousa.com ou écrire à : CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, M N 55447. Le client peut également appeler Relations avec la clientèle de CFMOTO au (888) 823-6686. ",
    bindingText3: "Données sur le comportement de conduite de l'utilisateur : y compris l'accélération, la décélération, la vitesse, la flexion, le dernier temps de conduite et le dernier kilométrage parcouru .",
    bindingText30: '5.\tRévisions _',
    bindingText31: '5.1.\tCFMOTO se réserve le droit de modifier cet avis à tout moment, mais nous publierons les révisions sur CFMOTO RIDE App et/ou fournir un avis avant que nous ne le fassions, le cas échéant.',
    bindingText4:
      "Données sur l'état du véhicule : se réfèrent à l'état en temps réel du véhicule, y compris le mode de conduite, le carburant résiduel, l'économie de carburant instantanée, le kilométrage, le rapport en temps réel du véhicule, la vitesse du moteur, la pression des pneus, la température des pneus, les données de tension d'activation de la batterie , température du liquide de refroidissement, état de la serrure électronique, version du logiciel de l'appareil intelligent, force du signal des appareils intelligents, réglage actuel du tableau de bord.",
    bindingText5:
      "Données d'alarme du véhicule : données d'alarme à envoyer si certaines données dépassent une valeur prédéfinie, telles que la température du moteur, une vitesse excessive, un temps de conduite excessif, une température élevée du liquide de refroidissement, un mouvement anormal du véhicule, une pression anormale des pneus, des vibrations, un déversement, une collision , etc. .",
    bindingText6: 'Informations sur les défauts du véhicule : fait référence aux codes de défaut signalés par chaque partie interne du véhicule.',
    bindingText7: 'Données de localisation du véhicule : fait référence à la localisation géographique spécifique du véhicule.',
    bindingText8: "1.1.\tFournir _ le client avec des services liés au véhicule via l' application CFMOTO RIDE .",
    bindingText9:
      "1.1.1.\tLes consommateurs peuvent gérer à distance les véhicules via l' application CFMOTO RIDE (y compris la visualisation de l'emplacement du véhicule, la définition des informations et des fonctions du véhicule, la télécommande de l'état du véhicule, etc.).",
    bindingUser: "Lier l'utilisateur",
    bothServices: 'Les deux services simultanément',
    bound: 'Lié',
    businessType: "Type d'entreprise",
    button: 'Boutons',
    callbackedApply: 'Vous avez retiré votre demande de suppression de compte le yyyy-MM-dd HH:mm:ss',
    callbackedApplySyncTip:
      "Votre demande de suppression de compte a été soumise le yyyy-MM-dd HH:mm:ss.  Nous supprimerons définitivement votre compte et les données associées 15 jours après réception de la demande. Après la suppression, vous ne pourrez plus utiliser le service CFMOTO RIDESYNC.  Pour annuler la suppression de votre compte, veuillez retourner la page web ou vous connecter à l'APP dans les 15 jours pour retirer la demande de suppression de compte.",
    callbackedApplyTip:
      "Votre demande de suppression de compte a été soumise le yyyy-MM-dd HH:mm:ss.  Nous supprimerons définitivement votre compte et les données associées 15 jours après réception de la demande. Après la suppression, vous ne pourrez plus utiliser le service CFMOTO RIDE.  Pour annuler la suppression de votre compte, veuillez retourner la page web ou vous connecter à l'APP dans les 15 jours pour retirer la demande de suppression de compte.",
    canadaPrivacyPolicy: 'Politique de confidentialité du Canada',
    canadaTelematicsPolicy: 'Accord télématique canadien',
    canadaUserPolicy: "Accord d'utilisation canadien",
    canadianAgreementText: "Texte de l'accord canadien",
    cancel: 'Annuler',
    cancellationAgreement: 'Accord de résiliation',
    cancelled: 'Annulé',
    carOwner: 'Propriétaire',
    carUserScore: 'Évaluations des propriétaires de véhicules',
    cardPass: "Vérification d'identité réussie !",
    cfmotoName: 'CFMOTO',
    changeCodeValidate: "Passer à l'authentification par code de vérification",
    changeDescriptionType: 'Changer la description',
    changeDescriptionTypeSelectNo: "N'implique pas de changements dans la réglementation sur le traitement des informations personnelles",
    changeDescriptionTypeSelectYes: 'Modifications de la réglementation concernant le traitement des informations personnelles',
    changeEmail: "Modifier l'e-mail",
    changeEmailInfo: 'Passer au courrier électronique',
    changeFail: 'La modification du statut a échoué',
    changeOne: 'Changement',
    changePassValidate: "Passer à l'authentification par mot de passe",
    changePasswordFailed: 'Échec du changement de mot de passe',
    changePasswordSuccessful: 'Changement de mot de passe effectué avec succès',
    changePhoneInfo: 'Passer au numéro de téléphone',
    changeStore: 'Changer de magasin',
    changeSuccess: 'Statut modifié avec succès',
    channelType: 'canal de rétroaction',
    characterLimitExceeded: 'Limite de caractères dépassée',
    checkConfigurationTwo: "Chinois anglais %s n'est pas configuré complètement, vérifiez",
    checkCopyWriting: "Le contenu chinois ou anglais n'est pas renseigné, veuillez vérifier",
    checkEmpty: '%s est vide, veuillez vérifier',
    checkEmptyEnglish: 'Anglais incomplet. Veuillez vérifier',
    checkTriggerType: "Il y a une condition du mécanisme de déclenchement qui n'a pas été remplie, veuillez vérifier",
    checkUpdate: 'vérifier les mises à jour',
    cityFilter: 'Filtre de ville',
    clickImmediateFeedback: 'Cliquez pour donner votre avis maintenant',
    clickNumber: 'Le nombre de clics',
    clickNumberDescription: 'nombre de notifications sur lesquelles les utilisateurs ont cliqué',
    clickNumberVolume: 'Nombre de clics',
    clickToFeedback: 'Cliquez sur les commentaires',
    clicks: 'Clic',
    closeNum: 'fermeture',
    closeTask: 'Tâche annulée',
    code: 'Code de vérification',
    colorPicture: 'Image de bloc de couleur',
    comment: 'Commentaire',
    commentContent: 'Commentaires',
    commentList: 'Liste des commentaires',
    commentNumber: 'Nombre de commentaires',
    commentTime: 'Heure des commentaires',
    communication: 'en communication',
    community: 'Communauté',
    communityManagement: 'Gestion de la communauté',
    communityRule: 'Règle de la communauté',
    completePuzzle: 'Veuillez compléter le puzzle',
    completed: 'complété',
    condition: 'condition',
    configureLanguage: 'Configurer la langue',
    configurePicture: "Configurer l'image",
    confirm: 'Confirmer',
    confirmDeletePictures: 'Confirmez pour supprimer cette photo',
    confirmRedeem: 'Confirmer la consommation',
    confirmReviewNoPass: "Confirmer l'échec de l'examen",
    confirmReviewPass: "Confirmer la réussite de l'examen",
    consultDealer: 'Veuillez consulter votre revendeur local',
    contact: 'Votre demande de suppression de compte a été rejetée. Si vous avez des questions, veuillez contacter it@cfmoto.com pour consultation.',
    contactMail: 'Adresse e-mail',
    contactMethod: 'Contact',
    contactUs: 'Contactez-nous',
    content: 'Contenu',
    contentType: 'Type du contenu',
    copyFail: 'Échec de la copie',
    copyLink: 'Copier le lien',
    copySuccess: 'Copié avec succès',
    copyWriting: 'Contenu contextuel',
    country: 'Pays/Région',
    countryCode: 'Code pays',
    countryName: 'Pays',
    countryNumber: 'Code du pays',
    countryRegion: 'Pays/Région',
    create: 'Nouvel ajout',
    createBy: 'Créateur',
    createStore: 'Créer un magasin',
    createTime: 'temps de creation',
    cs_CZ: 'tchèque',
    currency: 'Monnaie',
    currentConfig: 'Configuration actuelle',
    currentCountryStoreTotal: 'Nombre total de magasins dans le pays actuel',
    currentRedemptionRatio: 'Ratio de consommation actuel',
    currentTime: 'Heure actuelle',
    customPage: 'Page personnalisée',
    customSettings: 'Colonnes personnalisées',
    dashcamHelp: 'Aide Dashcam',
    dataDeletExplain: 'Instructions de suppression de données',
    dataDelete: 'Suppression de données',
    dataDeleteApply: 'Demande de suppression de données',
    dataFormatError: 'Erreur de format de données',
    dataPermissionScope: "Étendue de l'autorisation de données",
    dataType: 'Type de données',
    dayOne: 'jours une fois',
    days: 'journée',
    daysAgo: 'Il y a %s jours',
    de_DE: 'Allemand',
    dealDate: 'Heure du traitement',
    dealerOperationList: 'Liste des opérations du revendeur',
    dealerOperationQuery: "Recherche d'opérations de revendeur",
    dealerOperationRecord: "Enregistrement d'opération du concessionnaire",
    dealerStore: 'Magasins de distributeur',
    dealerStoreImportTempateName: "Modèle d'importation de magasin de concessionnaire",
    dealerStoreQuery: 'Requête des magasins de distributeur',
    dealers: 'Importateur',
    default: 'Par défaut',
    defaultMap: 'Carte par défaut',
    delete: 'Supprimer',
    deleteAccountSYNCStep: 'Vous pouvez suivre ces étapes pour demander la suppression de votre compte CFMOTO RIDESYNC',
    deleteAccountStep: 'Vous pouvez suivre ces étapes pour demander la suppression de votre compte CFMOTO RIDE',
    deleteDataSYNCStep: 'Vous pouvez suivre ces étapes pour demander la suppression de vos données CFMOTO RIDESYNC',
    deleteDataStep: 'Vous pouvez suivre ces étapes pour demander la suppression de vos données CFMOTO RIDE',
    deleteFail: 'Échec de la suppression',
    deleteFinish: 'Suppression terminée',
    deleteKolUserAuthentication: "Supprimer l'authentification de l'utilisateur KOL",
    deleteStore: 'Supprimer le magasin',
    deleteSuccess: 'Suppression effectuée avec succès',
    deleteTip: 'Es-tu sur de vouloir supprimer cette annonce? Une fois supprimées, les informations ne peuvent pas être récupérées',
    deleteVersionWarn: "S'il faut supprimer cet enregistrement de version",
    deleteVideo: 'Supprimer cette vidéo ?',
    detailAddress: 'Adresse complète',
    details: 'Détails',
    determine: 'Bien sûr',
    deviceCodeGet: "Obtenir le code de l'appareil :",
    deviceContent:
      "Le code d'équipement du récepteur de clôture électronique (appelé clé) est une chaîne de codes à 10 chiffres. Le code de l'équipement, le code QR et le marquage CE sont imprimés sur l'autocollant autocollant en PVC argenté. Il y a trois étiquettes au total, une a été apposée sur la carrosserie du véhicule (il faut soulever le coussin du siège pour voir) ; les deux autres sont placés dans le sac d'accessoires du véhicule. (Il est recommandé aux utilisateurs d'apposer l'étiquette sur le manuel du véhicule ou sur la télécommande)\nVeuillez appuyer et maintenir ON pour ouvrir la clé et mettre le code QR au dos de la clé dans le cadre de numérisation",
    deviceNo: "Numéro d'appareil associé",
    deviceNumber: "Numéro d'appareil",
    deviceTitle: "Contrôle du code de l'appareil",
    digitalKey: 'clé numérique',
    digitalKeyDesc: "Pas besoin de transporter une clé physique, prend en charge le déverrouillage du véhicule après la connexion via l'application Bluetooth (pris en charge par certains modèles)",
    directRelease: 'Publication directe',
    disagree: "Pas d'accord",
    displayNumberDescription: 'nombre de notifications affichées sur les appareils',
    displayNumberVolume: "Nombre d'affichages",
    displayOrder: "Ordre d'affichage",
    displayPicture: 'Schéma de présentation',
    donwloadTemplateDescription:
      "Veuillez d'abord télécharger le modèle, le remplir (le contenu ne prend en charge que le format texte), puis télécharger le fichier ; la taille du fichier est limitée à 2 Mo. Si la soumission échoue, veuillez réduire le contenu de manière appropriée.",
    download: 'Télécharger',
    downloadFailFile: 'Télécharger le fichier échoué',
    downloadSuccessful: 'Téléchargement réussi',
    downloadTemplate: 'Télécharger le modèle',
    downloading: 'Téléchargement…',
    ebookChoice: {},
    ebookEmpty: {},
    ebookPlaceholder: {},
    ebookSwitch: {},
    ebookTitle: {},
    edit: 'modifier',
    editAccountDeletExplain: "Modifier l'avis de suppression de compte",
    editActivity: "Modifier l'activité",
    editAppRating: 'Modifier le mécanisme de notation',
    editBanner: 'Modifier le Banner',
    editCanadaPrivacyPolicy: 'Modifier la politique de confidentialité du Canada',
    editCanadaTelematicsPolicy: "Modifier l'Accord télématique canadien",
    editCanadaUserPolicy: "Modifier le contrat d'utilisation du Canada",
    editDashcamHelp: 'Aide Dashcam éditée',
    editDataDeletExplain: "Modifier l'avis de suppression de données",
    editExhibitionCategory: 'Éditer une catégorie de boutique',
    editExhibitionSeries: 'Modifier la Série',
    editFunctionIntro: "Modifier l'introduction de la fonction",
    editHelpConfiguration: 'Modifier aide instructions configuration',
    editInformation: 'Modifier les informations',
    editInformationCategory: "Modifier la catégorie d'informations",
    editInformationContent: 'Modifier le contenu des informations',
    editKolUserAuthentication: "Éditer l'authentification de l'utilisateur KOL",
    editModelSeries: 'Modifier la série de modèles',
    editPicture: "Modifier l'image",
    editPushConfiguration: 'Modifier la configuration de poussée',
    editRemark: 'Modifier la note',
    editServiceIntroduce: "Introduction aux services d'édition",
    editShowroomModel: 'Modifier le modèle de showroom',
    editSuccess: 'Modifié avec succès',
    editTime: "Temps d'édition",
    editUnbindingCommitment: "Modifier l'engagement d'une application non contraignante",
    editUser: "Modifier l'utilisateur",
    editVehicleModel: 'Modifier le modèle',
    editVehicleModelCategory: 'Modifier une catégorie de modèle de voiture',
    effecting: "En attente d'activation",
    effectiveTime: 'Date effective',
    electricVehicle: 'Véhicule électrique',
    email: 'E-mail',
    emailAdress: 'Adresse e-mail',
    emailAdressTip: "Remarque :  Cette adresse e-mail est utilisée pour le contact client par e-mail.  Veuillez vous assurer que l'adresse e-mail est correcte",
    emailBindingFailed: 'Échec du verrouillage des e-mails',
    emailContent: "Contenu de l'e-mail",
    emailImportTemplate: "Modèle d'importation d'adresse e-mail",
    emailImportTemplateToDownLoad: 'Les adresses e-mail peuvent être importées par lots, cliquez pour télécharger',
    emailList: 'Liste de diffusion',
    emailManage: 'Gestion des e-mails',
    emailMass: "Envoi d'e-mails",
    emailSearch: 'Requête par e-mail',
    emailSendTip1: 'Note: Be sure to add the note in blue font below at the end of your email. If the text of your email is not in English, please translate it into the language you are using before adding it.',
    emailSendTip2: 'If you want to unsubscribe from such emails, go to the CFMOTO RIDE App, click the [Me] > [Settings] > [Message notification] to turn off the [Receive email marketing] function.',
    emailSendTip3: '*Emails without added notes will not be reviewed and approved.',
    emailText: 'E-mail',
    emailTitle: 'Sujet',
    en_US: 'Anglais',
    enableStatus: 'Statut activé',
    enabled: 'activer',
    endTime: 'Heure de fin',
    endTimeLargeStartTime: "L'heure de fin doit être postérieure à l'heure de début",
    enterAnswer: 'Veuillez entrer la réponse',
    enterCategory: 'Veuillez saisir la catégorie',
    enterCodeToSafeAccount: 'Pour assurer la sécurité de votre compte, veuillez confirmer les informations  du compte que vous souhaitez supprimer, et entrez votre mot de passe ou un code de vérification pour authentifier votre identité.',
    enterCodeToSafeData: 'Pour assurer la sécurité de vos données, veuillez confirmer les informations de votre compte, et saisir votre mot de passe ou un code de vérification pour authentifier votre identité.',
    enterIntroduceText: "Veuillez saisir le texte d'introduction",
    enterLink: "Veuillez entrer l'adresse du lien",
    enterPopupTitle: 'Veuillez saisir le titre de la fenêtre contextuelle',
    enterQueryConditionLookData: 'Après avoir entré les conditions de la requête, vous pouvez afficher les données',
    enterQuestion: 'Veuillez saisir une question',
    enterQuestionAndAnswer: 'Des questions et réponses en chinois et en anglais sont requises.',
    enterSureUrl: "Veuillez saisir l'URL correcte (l'URL doit commencer par http, https)",
    enterTypeOfLanguage: 'Les catégories chinoises et anglaises doivent être remplies',
    enterUnbindingCommitment: "Veuillez saisir une lettre d'engagement pour la demande de dégroupage",
    entrance: {},
    errorLatAndLon: 'La latitude et la longitude sont mal formatées, veuillez vérifier',
    errorLocation: 'Erreur de localisation',
    es_ES: 'Espagnol',
    estimatedTime: 'Temps estimé',
    everySet: 'Par paramètre',
    examineResultMessage: 'Nous vérifierons les documents de candidature dès que possible, veuillez faire attention à la barre de notification ou au centre de messagerie APP à temps.',
    example: 'précédent',
    exchange: 'Consommer maintenant',
    exchangeDescription1:
      "Cher propriétaire de CFMOTO, votre véhicule a été lié avec associé. Vous avez reçu un essai gratuit d'un an de services intelligents.\n Veuillez choisir les services que vous souhaitez activer :\n - Édition standard\n - MotoPlay Premium\n Veuillez lire et accepter les termes\n Voir « Accord de service intelligent »\n [Confirmer]\t",
    exchangeDescription2:
      "Veuillez consulter le manuel électronique pour plus de détails sur le véhicule. Vous bénéficierez également d'une période d'essai gratuite d'un an pour tous les services intelligents CFMOTO RIDE, à compter de la date de votre premier engagement.\n [Fermer] [D'accord]",
    exchangeDescription3:
      "Vous avez XXX km de miles disponibles. Consommer maintenant pour continuer à profiter du service intelligent CFMOTO RIDE. Si aucune action n'est effectuée, les données de miles seront conservées pendant 30 jours à partir du déblocage du compte. Les miles non consommés seront automatiquement effacés et ne pourront plus être restaurés en dehors de cette période.\n Êtes-vous sûr de vouloir consommer vos miles maintenant ? \n[Oui] [Non]\n\n*Les bonus liés à la consommation de miles seront associés avec le véhicule et en disposition de son prochain propriétaire.",
    exchangeDescription4: 'Vous avez XXX km de miles disponibles. Souhaitez-vous consommer vos miles pour continuer à\n bénéficier gratuitement du service CFMOTO RIDE Intelligent ?\n [Oui] [Non]',
    exchangeDescription5:
      "Rappel de service intelligent\n\n Cher propriétaire de CFMOTO : Il reste XXX jours de période d'essai gratuit pour le service intelligent CFMOTO. Si vous activez le service intelligent, il sera activé dans les 24 heures. Veuillez consulter régulièrement.\n\n [Confirmer]",
    exchangeDescription6: "Profitez d'une meilleure expérience de navigation grâce aux services de la navigation et de la protection sur l'écran, offerts de MotoPlay et basés sur Google Maps",
    exchangeRecords: 'Enregistrement de consommation',
    exchangeServiceTime: 'Vous disposez du mile disponible consommable pour des heures de service',
    exchangeSuccess: 'Consommé avec succès',
    exhibition: 'Gestion des Boutiques',
    exhibitionCategory: 'Catégorie de boutique',
    exhibitionCategoryList: 'Liste des catégories de boutique',
    exhibitionCategorySearch: 'Requête de catégorie de boutique',
    exhibitionSeries: 'Séries de Boutiques',
    exhibitionSeriesList: 'Liste des séries de boutique',
    exhibitionSeriesSearch: 'Requête de série de boutique',
    exportContent: 'Exporter le contenu',
    exportExcel: 'Exporter vers EXCEL',
    exportLengthExceedOfMonth: "La durée de l'exportation ne doit pas dépasser %s mois",
    externalLink: 'Lien externe',
    failed: 'Échoué',
    failedToPreview: 'Échec de la révision',
    feedBackResut: "Résultats du retour d'information",
    feedBackTime: 'Temps de réponse',
    feedBackVechle: 'Véhicule',
    feedbackAppQuestion:
      "Veuillez décrire en détail l'heure à laquelle le problème s'est produit, la version de l'APP, le modèle de téléphone portable, le chemin d'exploitation et la description du problème afin d'aider à localiser et à résoudre rapidement le problème !",
    feedbackDetails: "Détails de l'avis",
    feedbackGuideDesc: "Pour plus d'informations, veuillez nous contacter via le canal de commentaires ci-dessous",
    feedbackLabelFileList: 'Veuillez télécharger une photo',
    feedbackMapQuestion:
      "Si vous constatez que l'adresse ou les informations sur la rue affichées sur la carte de l'APP ne correspondent pas à la situation réelle, veuillez fournir votre région, les informations sur l'adresse (ou la rue) actuelle du problème et les informations routières réelles. Plus la description du problème est détaillée, plus il nous sera facile de dépanner et de mettre à jour avec précision les données cartographiques.",
    feedbackMessageSubmitError: 'Échec de la rétroaction',
    feedbackOtherQuestion: "Veuillez décrire quand cela s'est produit, comment cela s'est produit et le problème.",
    feedbackReceived: "Retour d'information reçu",
    feedbackRecord: 'Historique des retours',
    feedbackRulesFileListMaxSize: 'Le fichier téléchargé est trop grand',
    feedbackRulesFileListOverType: 'Formats non pris en charge',
    feedbackSubmitTip: 'Si vous avez des questions ou des commentaires, vous pouvez également contacter le centre de service client CFMOTO Mexique directement via WhatsApp (+52 18115286003) ou par e-mail (servicioalclient@cfmoto.com.mx).',
    feedbackSuggest: 'Nous vous invitons à nous faire part de vos suggestions, nous examinerons sérieusement vos idées.',
    feedbackSupplement: 'Veuillez ajouter une description du problème',
    feedbackText: 'Commentaires',
    feedbackType: 'Type de rétroaction (choix unique)',
    feedbackVehicleQuestion: "Veuillez décrire quand cela s'est produit, comment cela s'est produit et le problème.",
    female: 'Femme',
    fileCountExceed: 'Nombre de fichiers au - delà de la limite',
    fileSizeExceed: 'La taille du fichier dépasse la limite',
    fileUploadingPleaceWait: 'Téléchargement du fichier, veuillez patienter',
    finalOperator: 'Opérateur final',
    firstBindDate: 'Date de première association au véhicule',
    firstMenu: 'Menu de niveau 1',
    forcedUpgrade: 'Mise à jour forcée',
    forgetPassword: 'Mot de passe oublié',
    fourCarOfNumber: "Nombre d'utilisateurs de quatre-roues",
    fourWheel: 'moto',
    fourWheelConfig: 'Configuration véhicule adulte à quatre roues',
    fourWheeler: 'Quatre roues',
    fourWheelerMostClicks: 'Modèles à quatre roues avec le plus de clics',
    fourWheelowner: 'Propriétaires adultes de véhicules à quatre roues',
    fr_FR: 'Français',
    frankfurt: 'francfort',
    freeLastDayBasedata: "Durée gratuite pour l'édition standard",
    freeLastDayMotoplay: 'Durée gratuite MotoPlay',
    friday: 'Vendredi',
    fuctionIntro: 'Présentation de la fonction',
    fullscreen: 'Plein écran',
    funServiceIntro: 'Présentation du service de fonction',
    function: 'Fonction',
    functionConfiguration: 'Configuration des fonctions',
    functionConfigureTip: "La fonction ne s'applique qu'aux véhicules configurés au nom de l'importateur ou des utilisateurs dans le pays/la région",
    functionDescription: "Les fonctions ne sont disponibles que pour les véhicules du nom de l'importateur configuré.",
    functionDetail: "Configuration (selon l'importateur du véhicule)",
    functionIntroduce: 'Description de la fonction',
    functionSetting: 'Configuration des fonctions tout-terrain de la carte',
    functionalOverview: 'Aperçu des fonctions',
    galleryEntrance: 'Entrée de la galerie',
    galleryEntranceUploadRules: 'Exigences de format : jpg/jpeg/png, rapport recommandé 4:3, taille ne dépassant pas 5 Mo',
    gender: 'Sexe',
    generalAgreementText: "Texte de l'accord général",
    generalAlarm: 'Alarme générale',
    geofence: 'Barrière électronique',
    getCarPosition: "Obtenir l'emplacement du véhicule à temps",
    getCode: 'Envoyer',
    getExchangeRecordsError: "Échec d'accéder aux enregistrements de consommation",
    goCustomPage: 'Aller à la page personnalisée',
    goOffline: 'Hors ligne',
    goOnline: 'En ligne',
    goUrlLink: 'Aller au lien URL',
    groupTrail: 'Sentier de groupe',
    groupTrailConfig: "Configuration des fonctions tout-terrain de l'équipe",
    guest: 'Pas de voiture',
    haveTwo: 'Les deux.',
    havedWrite: 'Rempli',
    havedWriteAll: 'a été rempli',
    havedWriteAllOrEmpty: 'est rempli ou vide.',
    helpAndFeedback: 'Aide et commentaires',
    helpCenter: "centre d'aide",
    helpConfiguration: 'Aide pour illustrer la configuration',
    helpMessageHistoryDelete: 'Supprimer tous les enregistrements de recherche ?',
    helpful: 'Utile',
    hint: 'Indice',
    historyDelete: 'Supprimer tous les enregistrements de recherche ?',
    home: "Page d'accueil",
    homePage: "Page d'accueil personnelle",
    hour: 'Heure',
    hoursAgo: 'Il y a %s heures',
    iWantEnableStoreUserQuery: "Je veux activer la recherche d'utilisateur de magasin",
    iWantToPostStatistics: 'Je veux publier des statistiques',
    identification: 'Identification',
    identificationText: 'Identification',
    imageSizeExceed: 'Veuillez télécharger une image avec une largeur et une hauteur %s',
    imageUploadFailed: 'Échec du téléchargement de la photo',
    immediateRelease: 'Diffusion immédiate',
    immediateSend: 'Envoyer maintenant',
    imporFailedOfTableHeader: "Échec de l'importation. En-tête du fichier non correspondu",
    import: 'importer',
    importDetails: 'Détails des questions',
    importExcel: 'Importer EXCEL',
    importFail: "Échec de l'importation",
    importStatus: "Statut d'importation",
    importSuccessful: 'Importation réussie',
    importTemplate: 'Téléchargement de modèles',
    importer: 'importateur',
    importerAccountOperationRecord: "Enregistrement d'opération et de connexion du compte importateur",
    importerAvatar: "Avatar de l'importateur",
    importerDisplayName: "Nom d'affichage de l'importateur",
    importerEnquiry: "Enquête sur l'importateur",
    importerManagement: "Gestion de l'importateur",
    importerOperationRecords: "Dossiers d'exploitation de l'importateur",
    importing: 'Importation en cours...',
    inProcess: 'contre-mesures',
    inProgress: 'en cours',
    individualCenter: 'Centre individuel',
    informationCategory: "Catégorie d'informations",
    informationCategoryList: "Liste des catégories d'informations",
    informationCategoryQuery: "Requête de catégorie d'informations",
    informationContent: "Contenu de l'information",
    informationContentList: 'Liste du contenu des informations',
    informationCotnentQuery: "Requête de contenu d'information",
    informationCover: "Couverture d'information",
    informationDetails: "Détails de l'information",
    informationImage: 'Image de couverture',
    informationManagement: "Gestion de l'information",
    informationTitle: "Titre d'information",
    informer: 'Informateur',
    informerId: "ID de l'informateur",
    initialPassword: 'Mot de passe initial',
    inputAgreementContent: "Veuillez saisir le contenu de l'accord",
    inputCannotExceed20000: "Saisir jusqu'à 20000 caractères",
    inputErrorEmoji: "Veuillez ne pas saisir d'émoticônes",
    installDeviceYouCan: 'Durch die Installation dieses Geräts können Sie',
    installVehicleModelAdd: 'Ajouter une description du modèle modifié',
    installVehicleModelDescription: 'Description du modèle modifié',
    installVehicleModelEdit: 'Modifier la description du modèle modifié',
    instrumentLastedVersion: 'Écran TFT pas besoin de mise à jour',
    instrumentupgrade: "Mise à niveau de l'écran TFT",
    inteligentServiceReminder: 'Rappel sur le Service Intelligent',
    intelligentInternetServiceIntroduction: 'Introduction au service',
    intelligentServiceAgreement: "l'Accord de service intelligent",
    intelligentServices: 'Services intelligents (détails sur le véhicule, données de la conduite, OTA)',
    introText: "Texte d'introduction",
    introduction: 'Introduction',
    invalidVercode: 'Code de vérification invalide',
    invoicePreview: 'Aperçu de la facture',
    invoicing: 'Facturation en cours',
    invoicingFailed: 'Échec de la facturation',
    invoicingSucceeded: 'Facturation réussie',
    iovNotice1: 'Les fonctions ci-dessus sont basées sur le dispositif de mise en réseau du véhicule (T-Box), veuillez consulter le concessionnaire local pour acheter et installer',
    iovNotice2: 'Les fonctions ci-dessus sont différentes selon la configuration de chaque modèle et la région où il se trouve. Veuillez consulter le concessionnaire local pour plus de détails.',
    iovNotice3: "Veuillez enregistrer et enregistrer le numéro de l'appareil à l'avance, ce qui est requis lors de la liaison de l'appareil. Après avoir terminé la liaison et l'installation, vous pourrez découvrir plus de fonctions",
    isHelpful: 'Aide-t-il?',
    isStop: "S'il faut arrêter",
    isSupportedChildOwnerOffMapDown: 'Si les propriétaires de véhicules non adultes prennent en charge le téléchargement de cartes hors ligne',
    isSupportedNoOwnerOffMapDown: 'Si les non-propriétaires de véhicules prennent en charge le téléchargement de cartes hors ligne',
    isSupportedOffMapDown: 'Si le téléchargement de cartes hors ligne est pris en charge',
    it_IT: 'italien',
    iterativeVehicleFunctions: 'Les parties principales du véhicule peuvent être mises à niveau en ligne à distance pour itérer en continu les fonctions du véhicule',
    jumpSettings: 'Paramètres de saut',
    jumpTarget: 'Cible de saut',
    jumpToWeb: 'En savoir plus sur notre site web',
    jumpUrl: 'Lien de redirection',
    justNow: "À l'instant",
    keySharing: 'Clé numérique et partage de clés',
    kolUser: 'Utilisateur KOL',
    kolUserList: 'Liste des utilisateurs KOL',
    kolUserManagement: 'Gestion des utilisateurs KOL',
    kolUserQuery: 'Requête des utilisateurs KOL',
    language: 'Langue',
    language1: 'Langue associée',
    languages: 'Langue',
    lastLoginTime: 'Dernière heure de connexion',
    lastModifiedBy: 'Dernière modification par',
    lastUpdateTime: 'Dernière heure de mise à jour',
    latitude: 'longitude',
    launchActivity: "Lancer l'activité",
    likeNumber: 'Nombre de likes',
    linkAddress: 'Adresse du lien',
    linkUrlDescription: "L'URL doit commencer par http, https",
    linkedOrder: 'Commande concernée',
    listDisplayImages: 'Affichage de la liste',
    listOfImporters: 'Liste des importateurs',
    listOfQuestion: 'Liste des questions',
    listShowStoreCoverPic: "Liste d'affichage de la couverture de la boutique",
    loadMore: 'En savoir plus',
    loadSuccess: 'Chargement terminé',
    loading: 'Chargement',
    locationFail: 'Échec du positionnement',
    log: 'Journal',
    login: "S'enregistrer",
    loginCountry: 'Pays/région de connexion',
    loginSuccessfully: 'Connexion effectuée avec succès',
    logout: 'Déconnecter',
    longitude: 'longitudes',
    loosing: 'Des données rafraîchissantes...',
    lowCompatibleVersion: 'Version minimale compatible',
    mail: 'E-mail',
    male: 'Homme',
    manualReviewStatus: 'Statut de révision manuelle',
    mapManage: 'Gestion des cartes',
    marketDataOfdealerStores: 'Données de marché des magasins concessionnaires',
    masteringCyclingData: 'Données de pilotage de base',
    maximum: 'Max.',
    maximumBannerCountTip: "Un maximum de %s banners peuvent être en ligne en même temps.  Veuillez d'abord en supprimer au moins un.",
    maximumMileage: 'Mile(s) maximum(s) consommable(s)',
    maximumValue: 'Maximum',
    menuFunctionName: 'Nom de la fonction du menu',
    menuIcon: 'Icône de menu',
    messagePush: 'Poussée de message',
    messagePushDeleteAsk: 'Êtes-vous sûr(e) de vouloir supprimer cette poussée ?',
    messagePushDownloadTemplate:
      "Veuillez d'abord télécharger le modèle et téléverser le fichier après avoir rempli le fichier du modèle.  La taille du fichier est limitée à 2 M.  En cas d'échec de la soumission, veuillez réduire le contenu de manière appropriée",
    messageWithdrawAsk: 'Voulez-vous retirer cette poussée ?',
    middle: 'milieu',
    min: 'Min',
    minAgo: 'Il y a %s min',
    minimum: 'Min.',
    minimumValue: 'Minimum',
    modelDetail: 'Détails du modèle',
    modifyFail: 'Échec de la modification',
    modifyPassword: 'Modifier le mot de passe',
    modifySuccess: 'Modification effectuée avec succès',
    monday: 'Lundi',
    more4pic1video: 'Maximum 4 images / 1 vidéo',
    moreDetailsConsultDealerStore: 'Pour plus de détails, veuillez consulter le service client du concessionnaire',
    morning: 'Matin',
    motoPlay: "MotoPlay (service basé sur Google de la navigation et de la protection sur l'écran)",
    motoPlayAgreement: "Statut de l'accord MotoPlay",
    motoplatNavigationScreen: "Projection sur l'écran de navigation MotoPlay",
    motoplayServicePay: 'Paiement pour MotoPlay',
    motoplayServiceResetTimeRule: "L'heure de réinitialisation de MotoPlay ne peut pas être postérieure à l'heure actuelle",
    motorcycle: 'deux-roues',
    moveDown: 'Déplacer vers le bas',
    moveLongPressMap: 'Déplacez ou appuyez longuement sur la carte pour sélectionner un emplacement',
    moveMapSelectPoint: 'Déplacer la carte pour sélectionner un point',
    moveTo: 'Déplacer vers',
    moveToBottom: 'Déplacer en bas',
    moveToTop: 'Déplacer en haut',
    moveToTopStatus: 'Statut épinglé',
    moveTop: 'Épinglé',
    moveUp: 'Déplacer vers le haut',
    multimedia: 'Multimédia',
    mustInteger: 'Doit être un entier positif',
    mute1Day: 'Être banni pendant 1 jour',
    mute2Days: 'Être banni pendant 2 jours',
    mute30Days: 'Être banni pendant 30 jours',
    mute3Days: 'Être banni pendant 3 jours',
    mute7Days: 'Être banni pendant 7 jours',
    muting: 'Banni',
    nameOfImporter: "Nom de l'importateur",
    navigation: 'Navigation sur carte',
    nearLoginTime: 'Dernière heure de connexion',
    needPopup: "Besoin d'une fenêtre pop-up",
    negativeNum: 'Mauvaise critique',
    networkException: 'Exception réseau',
    newAddFail: "Échec de l'ajout",
    newAddSuccess: 'ajouté avec succès',
    newBanner: 'Nouvel Banner',
    newCancellationAgreement: "Nouvel accord d'annulation",
    newEmail: 'Nouveau e-mail',
    newEmailEqualsValidate: "L'adresse e-mail nouvelle ne peut pas être identique à l'adresse originale",
    newFunctionIntro: 'Introduction de nouvelles fonctions',
    newMenuFunction: 'Nouvelle fonction du menu',
    newModelSeries: 'Nouvelle série de modèles',
    newPassword: 'Nouveau mot de passe',
    newPasswordNotEqual: 'Le nouveau mot de passe entré deux fois est incohérent, veuillez le saisir à nouveau',
    newQuestionType: 'Ajouter de nouvelles catégories de questions',
    newStoreNumber: 'Nombre de nouveaux magasins',
    newTopic: 'Nouveau sujet',
    newUnbindingCommitment: "Nouveau formulaire d'engagement de dégroupage",
    nextStep: 'Suivant',
    nickName: 'Pseudo',
    no: 'Non',
    noContent: 'Aucun contenu associé',
    noContent2: 'Suggérer de changer de mots-clés ou',
    noData: 'Pas de données',
    noExchangeRecord: "Pas encore d'enregistrement de consommation",
    noFeedbackRecord: "Il n'y a pas d'enregistrement des réactions pour le moment.",
    noJump: 'Pas de saut',
    noLog: 'Aucun journal',
    noMores: 'Rien de plus',
    noNeedPopup: 'Aucune fenêtre contextuelle requise',
    noOkToFeedback: 'Non résolu, je veux donner des commentaires',
    noOwnerScore: 'Évaluations des non-propriétaires',
    noPass: 'Rejeté',
    noSendPeople: "Pas d'expéditeur",
    noSortingPermission: "Pas d'autorisation de tri",
    noSupportMapDown: "Le téléchargement de carte hors ligne n'est pas pris en charge",
    noThisPermission: "Pas d'autorisation pour cette opération",
    noUserSelected: 'Aucun utilisateur sélectionné, impossible de soumettre',
    nofiledSeviceContent: "L'introduction du service n'est pas renseignée",
    nonOwner: 'Non-propriétaire',
    nonVehicleOwnerCharged: "Les non-propriétaires de véhicules seront facturés après l'essai",
    none: 'Aucun',
    normal: 'Normal',
    notAllowImageAndVideo: 'La vidéo ne peut pas être sélectionnée lors de la sélection des images',
    notAllowed: 'Non autorisé',
    notBeLessOrEqual: 'Ne doit pas être inférieur ou égal à',
    notDeleted: 'Non enregistré',
    notDistributedYet: 'Non publié',
    notEnabled: 'Pas activé',
    notHelpful: 'Inutile',
    notLessThan: 'Ne doit pas être inférieur à',
    notRecommended: 'Non recommandé',
    notReleasedYet: 'Pas encore publié',
    notStarted: "N'a pas commencé",
    'notSupportT-Box': "Désolé, votre véhicule ne prend pas en charge de l'extension T-Box",
    notTop: 'Non épinglé',
    notice: 'Remarquer',
    noticeText1: 'Dear CFMOTO users,',
    noticeText2:
      'Hello! We sincerely thank you for your continuous support and trust in CFMOTO. In order to continuously improve your service experience, we are committed to enhancing service quality and implementing innovative improvements. In this context, we have made business adjustments and hereby notify you that as of 08/10/2024, we will discontinue the CFMOTO RIDE App (the "App") in the United States. In order to ensure that your service experience is not affected, we have launched a brand-new CFMOTO RIDESYNC App. We hope you can continue to enjoy our new services through this new app.',
    noticeText3: 'Important notes:',
    noticeText4: '1. From today on, this app will only be available for bound CFMOTO vehicles in the United States and no longer support binding new vehicles. If you need to bind a new vehicle, please download and use the CFMOTO RIDESYNC App.',
    noticeText5:
      '2. We strongly recommend that you download and use the CFMOTO RIDESYNC App before 08/10/2024 so that you can continue enjoying our services seamlessly. We provide you with a convenient data migration service. You can choose to migrate all data retained in this App to the CFMOTO RIDESYNC App to preserve your personal information, vehicle information and past service records. We will ensure your data security and privacy during the migration process. If you want to use the CFMOTO RIDESYNC App without migrating data, you can re-register with the CFMOTO RIDESYNC App to use the new services. Click on the button below to learn how to download and use the CFMOTO RIDESYNC App.',
    noticeText6:
      '3. Please note that after 08/10/2024, you will no longer be able to use the relevant services of the App in the United States. Meanwhile, we will delete all personal data generated during your use of the App according to the relevant laws and regulations.',
    noticeText7:
      'We are fully aware that this change may cause temporary inconvenience to you, but we believe that with this service upgrade, you will have a richer and more satisfying user experience. If you encounter any issues or have questions during this process, we will always be here to help. Thank you for your understanding and cooperation, and we look forward to serving you in the CFMOTO RIDESYNC App.',
    noticeText8: 'Wish you a happy life!',
    notzero: 'Les numéros de version ne peuvent pas tous être 0',
    obtainVerificationCode: 'Obtenir le code de vérification',
    officiaAndKolList: 'Liste officielle/KOL',
    officialAccount: 'Compte officiel',
    officialAccountAuth: 'Authentification du compte officiel',
    officialIrKOLSearch: 'Recherche officielle/KOL',
    officialKolAuth: 'Authentification officielle/KOL',
    offline: 'Hors ligne',
    offlineAlready: 'Hors ligne',
    offlineTime: 'Temps hors ligne',
    offlineTimeMustBeGreaterThan: 'Le temps hors ligne doit être supérieur à',
    ok: 'OK',
    oldPassword: 'Ancien mot de passe',
    onLineAlready: {},
    oneMonths: 'Un mois',
    oneYear: 'Un an',
    online: 'En ligne',
    onlyFourWheel: 'Quatre roues seulement',
    onlyTwoWheel: 'Deux roues seulement',
    openEveryCount: 'Ouvert à chaque fois',
    openEveryDay: 'Ouvert tous les jours',
    openProductType: 'Types de produits ouverts',
    operationRecord: "Enregistrement d'opération",
    operationTime: "Temps d'opération",
    operations: 'Opérations',
    operator: 'Opérateur',
    operattor: 'Opérateur',
    opreate: {},
    opreateFunSet: {},
    opreateFunSetAdvert: {},
    opreateFunSetAdvertAdd: {},
    opreateFunSetAdvertEdit: {},
    opreateFunSetAdvertView: {},
    optionalUpgrade: 'Mise à jour facultative',
    orderFeedBackNum: 'Nombre de retours de la commande',
    orderList: 'Liste de commandes',
    orderMange: 'La gestion des commandes',
    orderNum: 'Numéro de commande',
    orderQuestion: "Décrivez l'heure à laquelle le problème s'est produit et ses détails, puis téléverser une ou plusieurs captures d'écran. Pour les problèmes de paiement, veuillez également téléverser le relevé de prélèvement",
    originalEmail: 'E-mail original',
    otaUpgradeVehicle: 'Véhicule de mise à niveau OTA',
    otaUpgradeVehicleDesc: 'Les principaux composants du véhicule peuvent être mis à niveau à distance pour itérer en permanence les performances du véhicule.',
    other: 'Autres',
    over: 'plus de',
    owner: 'Il y a une voiture',
    ownerIdHomepageImage: "Page principale de la carte d'identité, du permis de conduire ou du passeport contenant des informations d'identification personnelle",
    parameterConfiguration: 'Configuration des paramètres',
    partialImportFailed: "Échec de l'importation partielle",
    pass: 'Approuvé',
    passValidateDeleteAccount: "Vérification d'identité réussie !  Cliquez sur le bouton Soumettre la demande en bas pour demander la suppression du compte",
    password: 'Mot de passe',
    passwordRuleText: '8 à 20 caractères, doivent contenir des lettres anglaises majuscules et minuscules, des chiffres et des caractères spéciaux',
    passwordRules: 'Règles de mot de passe',
    paySetting: 'Gestion de la recharge cartographique',
    payStrategy: 'Stratégie de paiement',
    paymentLastDayBasedata: "Durée payée pour l'édition standard",
    paymentLastDayMotoplay: 'Durée payée MotoPlay',
    peleaseEnterProvince: "Veuillez indiquer la province ou l'état",
    pendSend: 'En attente',
    pending: 'En attente.',
    pendingSubmit: 'En attente de soumission',
    permanentMuting: 'Muet en permanence',
    phoneModel: 'Modèle',
    phoneNum: 'numéro de téléphone',
    phoneNumber: 'Numéro de téléphone',
    phoneOrEmail: 'Numéro de téléphone/E-mail',
    phoneOrEmailImportTemplate: "Modèle d'importation de numéro de téléphone portable/adresse e-mail",
    phoneOrEmailNotRegistered: "Ce numéro de téléphone portable ou cette adresse électronique n'est pas enregistré(e)",
    phoneOrEmailOrUserId: 'Numéro de téléphone portable/adresse e-mail/ID utilisateur',
    picture: 'Image',
    pl_PL: 'polonais',
    pleaseAddImage: 'Veuillez ajouter des fichiers image',
    pleaseAddVideoFile: 'Veuillez ajouter des fichiers vidéo',
    pleaseEnter: 'Veuillez entrer',
    pleaseEnterAccountInfo: 'Veuillez saisir les informations du compte',
    pleaseEnterAmount: 'Veuillez saisir le montant',
    pleaseEnterCity: 'Veuillez saisir une ville',
    pleaseEnterEmail: 'Veuillez saisir votre adresse e-mail',
    pleaseEnterEmailAdress: "Vérifiez saisir l'adresse e-mail",
    pleaseEnterIntro: "Veuillez entrer l'introduction",
    pleaseEnterLatAndLong: 'Veuillez saisir la latitude et la longitude',
    pleaseEnterNewPassword: 'Veuillez saisir le nouveau mot de passe',
    pleaseEnterPassword: 'Veuillez saisir le mot de passe',
    pleaseEnterPhone: 'Veuillez saisir votre numéro de téléphone',
    pleaseEnterQuestionDescription: 'Veuillez entrer une description de votre problème',
    pleaseEnterRealname: 'Veuillez saisir votre vrai nom',
    pleaseEnterRemark: 'Veuillez entrer des remarques',
    pleaseEnterServePhone: 'Veuillez saisir le numéro de service',
    pleaseEnterStoreAddressDetail: "Veuillez saisir l'adresse détaillée",
    pleaseEnterStoreIntroduce: 'Veuillez saisir la présentation du magasin',
    pleaseEnterStoreName: 'Veuillez saisir le nom du magasin',
    pleaseEnterStoreRemarkName: 'Veuillez saisir le nom de la remarque du magasin',
    pleaseEnterTitle: 'Veuillez entrer un titre',
    pleaseEnterUsername: "Veuillez saisir un nom d'utilisateur",
    pleaseEnterVercode: 'Veuillez saisir le code de vérification',
    pleaseEnterVersion: 'Veuillez entrer le numéro de version',
    pleaseEnterVersionIntroduction: "Veuillez saisir l'introduction de la version",
    pleaseEnterVideoDetail: 'Veuillez saisir les détails de la vidéo',
    pleaseEnterVin: 'Veuillez saisir le VIN',
    pleaseInputWord: 'Veuillez entrer un mot-clé',
    pleaseLoginFirst: "Veuillez d'abord vous connecter",
    pleaseRepeatNewPassword: 'veuillez répéter le nouveau mot de passe',
    pleaseSelect: "Choisissez s'il vous plaît",
    pleaseSelectAuthAccount: 'Sélectionner un compte authentifié',
    pleaseSelectBusinessHours: "Veuillez sélectionner les heures d'ouverture",
    pleaseSelectCity: 'Veuillez sélectionner une ville',
    pleaseSelectCountry: 'Veuillez sélectionner un pays',
    pleaseSelectCurrency: 'Veuillez sélectionner une devise',
    pleaseSelectMatchingMultimediaContent: 'Veuillez sélectionner le contenu multimédia correspondant',
    pleaseSelectPayChannel: 'Veuillez sélectionner un canal de paiement',
    pleaseSelectProblemWhere: 'Veuillez sélectionner un scénario dans lequel le problème se produit',
    pleaseSelectProducType: 'Veuillez sélectionner le type de produit',
    pleaseSelectProvince: 'Veuillez sélectionner une province/région',
    pleaseSelectQueType: 'Veuillez sélectionner le type de question',
    pleaseSelectReportReason: 'Veuillez sélectionner le motif de la déclaration',
    pleaseSelectService: "Sélectionnez d'abord un service",
    pleaseSelectStatus: 'Veuillez sélectionner le statut',
    pleaseSelectStoreType: 'Veuillez sélectionner le type de magasin',
    pleaseSelectTimedSendTime: "Veuillez sélectionner l'heure d'envoi",
    pleaseSelectUserTheList: 'Veuillez sélectionner un utilisateur dans la liste',
    pleaseSelectVehicle: 'Veuillez sélectionner un véhicule',
    pleaseSelectVehicleConfig: 'Veuillez sélectionner la configuration du véhicule',
    pleaseSelectlinkedOrder: 'Veuillez choisir une commande liée.',
    pleaseSelectupgradeType: 'Veuillez sélectionner la méthode de mise à jour',
    pleaseSureType2: 'Veuillez vous assurer que tout ce qui figure dans',
    pleaseUpload: 'Veuillez télécharger',
    pleaseUploadPicVideo: 'Veuillez télécharger des photos/vidéos',
    pleaseUserTimeFill: "Veuillez remplir selon l'heure de l'utilisateur du terminal",
    popUpFrequencyType: 'Formulaire de fenêtre contextuelle',
    popUpFrequencyValue: 'Fréquence des pop-ups',
    popUpFrequencyValueValid: 'Veuillez sélectionner les jours de fréquence',
    popUpReminder: "S'il faut afficher un rappel",
    popupArea: 'plage utilisateur pop-up',
    popupCreate: 'Ajouter une fenêtre pop-up',
    popupDayOne: 'Une fois par nombre de jours défini',
    popupEdit: 'Modifier la fenêtre contextuelle',
    popupFrequency: 'Fréquence des pop-ups',
    popupManagement: 'Gestion des fenêtres pop-up',
    popupOne: 'Jouez une seule fois',
    popupPosition: 'Emplacement de la fenêtre contextuelle',
    popupStatus: 'État de la fenêtre contextuelle',
    popupTarget: 'Cible pop-up',
    popupTime: 'Heure du pop-up',
    popupTitle: 'Titre de la fenêtre contextuelle',
    positiveNum: 'Bonnes critiques',
    postComment: 'Commentaire du post',
    postContent: 'Contenu du post',
    postId: 'ID de publication',
    postList: 'Liste des posts',
    postManagement: 'Gestion du post',
    postSearch: 'Recherche de post',
    posts: 'Posts',
    precautionText1:
      'Hello! As you have learned that we will discontinue the CFMOTO RIDE App (hereinafter referred to as "the App") in the United States from 08/10/2024, to assist you with this change, please take note of the following important matters:',
    precautionText2: '1. From today on, you will not be able to bind a new vehicle through the APP to enjoy relevant vehicle services.',
    precautionText3: '2. To ensure a smooth transition to the new service, we have provided an entry at the top of the vehicle page in this App. You can learn how to download and use the CFMOTO RIDESYNC App at any time through that entry.',
    precautionText4:
      '3. Please note that once the service ceases to take effect, you will no longer be able to enjoy any services of the App in the United States. At the same time, we will delete all personal data generated during your use of the App in accordance with relevant laws and regulations. This means that we will not be able to respond to any of your requests for data after the service is discontinued.',
    precautionText5:
      'We understand that this change may cause inconvenience to you, but we are committed to continuously protecting your data security and privacy. We encourage you to take early action to download and start using the CFMOTO RIDESYNC App in a timely manner so that you can continue to enjoy the quality service provided by CFMOTO. If you have any questions or need assistance in this process, please do not hesitate to contact us. We look forward to serving you in the CFMOTO RIDESYNC App.',
    privacyContent: 'Détails du contenu de la politique de confidentialité',
    privacyPolicy: 'Politique de confidentialité',
    privacyPopupAgree: "Obtenez à nouveau le consentement de l'utilisateur à la politique de confidentialité via une fenêtre pop-up",
    privacyVersion: 'Version de la politique de confidentialité',
    privacyVersionList: 'Liste des versions de la politique de confidentialité',
    problemaDes: 'Description du problème',
    processMethod: 'Méthodes du traitement',
    processReason: 'Raison du traitement',
    processReasonDetails: 'Détails de la raison du traitement',
    processRecord: 'Registre du traitement',
    processReport: 'Traiter les dénonciations',
    processSolution: 'Solution du traitement',
    processUser: 'Gestion des utilisateurs',
    processed: 'Traité',
    productDetails: 'Détails du produit',
    productTime: 'temps de production',
    prohibitDecimalsAndNegative: 'Les nombres décimaux et négatifs sont interdits',
    pt_PT: 'Portugais',
    publishInformation: 'Publier des informations',
    publishPosts: 'Publier des posts',
    pullBefore: 'Tirez vers le bas pour rafraîchir.',
    pulling: 'Actualiser maintenant',
    purchaseAndInstall: 'Acheter et installer',
    pushConfiguration: 'Configuration de poussée',
    pushContent: 'Pousser du contenu',
    pushList: 'Liste de poussée',
    pushMode: 'Mode de poussée',
    pushNow: 'Pousser maintenant',
    pushQuery: 'Requête de poussée',
    pushRecord: 'Enregistrement de poussée',
    pushScope: 'Plage de poussée',
    pushTime: 'Temps de poussée',
    pushTimeDifferenceAsk: "L'heure d'envoi que vous choisissez peut empêcher certains utilisateurs de recevoir ce push en raison du décalage horaire. Êtes-vous sûr de vouloir enregistrer ?",
    pushTitle: 'Titre de poussée',
    pushed: 'Poussé',
    pushing: 'Poussée en cours',
    quantity: 'Quantité',
    query: 'Rechercher',
    question: 'Question',
    questionInquiry: 'Demande de questions',
    questionType: 'Type de question',
    questionTypeList: 'Liste de classification des questions',
    questionTypeTemplate: "Centre d'aide – Modèle de classification des problèmes",
    quickRelease: 'Publication rapide',
    ranking: 'Classement',
    ratingWarn1:
      "Pour les utilisateurs propriétaires de véhicules, le contrôle du service intelligent correspondant au pays/région dans l'arrière-plan de gestion n'a pas été activé ou le service de service intelligent n'a pas expiré après avoir été activé. Le véhicule est en ligne et possède",
    ratingWarn2: "enregistrements de conduite complets ou plus (le début et la fin de chaque trajet sont des événements signalés), une fenêtre contextuelle apparaîtra lorsque l'utilisateur quittera My Cycling et reviendra à la page d'accueil.",
    reUpgrade: 'Retenter',
    readAgree: 'Lire et accepter les',
    readAndAgree: 'Veuillez lire et accepter',
    readAndAgreeTo: "J'ai lu et accepté les",
    readDeleteStep: 'comprendre les types de données que nous supprimerons ou conserverons et toute période de conservation supplémentaires',
    realname: 'Nom réel',
    reasonForReport: 'Raison',
    receiveCarReminderMessage: 'Recevoir des alertes de messages de véhicules',
    rechargeAmount: 'Montant de la recharge',
    rechargeChannel: 'Canaux de recharge',
    rechargeStatus: 'État de recharge',
    rechargeTime: 'Temps de recharge',
    recharged: 'Rechargé',
    recipients: 'Destinataire',
    recipientsNum: 'Portée du destinataire',
    recommended: 'Recommandé',
    recommendedStatus: 'Statut recommandé',
    redeemableServiceHours: 'Heures de service disponible dans la consommation',
    redemptionMileage: 'Consommation de miles',
    redemptionRatio: 'Ratio de consommation',
    redemptionTime: 'Date de consommation',
    redirectUrl: 'URL de redirection',
    refreshInterval: 'Temps de rafraîchissement',
    refreshSend: 'renvoyer',
    refundFailed: 'Le remboursement a échoué',
    refunded: 'Remboursé',
    refunding: 'Remboursement en cours',
    refused: 'Rejeté',
    registerDate: "Heure d'inscription",
    rejected: 'rejeté',
    releaseContent: 'Publier une histoire',
    releaseMethod: 'Méthode de publication',
    releaseMute: 'Annuler le bannissement',
    releaseTime: 'Temps de libération:',
    released: 'Publié',
    releasedBy: 'Publié par',
    remainServiceHavExpired: "Temps restant jusqu'à l'expiration du service intelligent",
    remainingAvailableMileage: 'Mile(s) disponible(s) restant(s)',
    remark: 'Notes',
    rememberPassword: 'Se souvenir du mot de passe',
    reminder: 'Rappel',
    remove: 'Supprimer',
    removeOnlinUpgrade: 'Véhicule de mise à niveau en ligne à distance',
    repeatNewPassword: 'Répéter le nouveau mot de passe',
    replaceTBOX: 'Remplacer TBOX',
    replied: 'répondu',
    reply: 'Répondre',
    report: 'Rapport',
    reportList: 'Liste des rapports',
    reportManagement: 'Gestion de la dénonciation',
    reportReason: 'Raison de la dénonciation',
    reportReasonDetails: 'Détails de la raison de la dénonciation',
    reportReasonPlaceholder: 'Écrivez ce que vous voulez rapporter, 0-1500 mots',
    reportSearch: 'Recherche de la dénonciation',
    reportSuccessful: 'Rapport réussi, nous le traiterons dès que possible',
    reportTime: 'Heure de la dénonciation',
    reportType: 'Type de rapport',
    reportedContent: 'Contenu dénoncé',
    reportedUser: 'Utilisateur dénoncé',
    reportedUserId: "ID de l'utilisateur dénoncé",
    requestTimedOut: 'La demande a expiré',
    resend: 'Envoyer de nouveau',
    resendTo: 'Envoyer de nouveau à',
    reset: 'Réinitialiser',
    resetItem: 'Élément de réinitialisation',
    resetTime: 'Heure de réinitialisation du service intelligent',
    resetWarn: "Après la réinitialisation, la durée gratuite des services intelligents de ce véhicule sera recalculée et prendra effet en fonction de l'heure actuelle (heure du navigateur). Veuillez confirmer si vous souhaitez réinitialiser.",
    return: 'Retour',
    review: 'Révision',
    reviewApproved: 'Révision réussie',
    richText: 'Texte riche',
    ro_RO: 'roumain',
    roleDescription: 'Description du rôle',
    roleName: 'Nom du rôle',
    rolePermission: 'Autorisation du rôle',
    'routerTitleBinding-agreement': '绑车协议',
    routerTitleDownload: 'CFMOTO RIDE APP Download',
    routerTitleEbook: 'ebook',
    routerTitleIntroduce: '介绍',
    routerTitleOrderConfirm: 'Order Confirmation',
    routerTitlePdf: 'PDF',
    ru_RU: 'russe',
    safeRemind: "Pour protéger la sécurité de votre compte, veuillez ne pas soumettre d'informations personnelles sensibles ici, telles que les mots de passe des comptes, etc.",
    satelliteMap: 'Carte satellite',
    saturday: 'Samedi',
    save: 'Sauvegarder',
    saveAndPreview: 'Enregistrer et prévisualiser',
    saveAsDraft: 'Enregistrer comme brouillon',
    saveFail: 'Échec de la sauvegarde',
    savePicture: "Enregistrer l'image",
    saveSettings: 'Enregistrer les paramètres',
    saveSuccess: 'Sauvegardé avec succès',
    saveVideo: 'Enregistrer la vidéo',
    scanQrcodePreview: 'Scannez le code QR ci-dessous avec votre téléphone portable pour prévisualiser',
    screenNavigationGuidance: 'Installer instructions',
    sdkStatement: 'Déclaration SDK',
    search: 'Recherche',
    searchRecords: 'Recherche historique',
    secondaryMenu: 'Menu secondaire',
    securityMessage: "Les informations ci-dessus sont utilisées pour la vérification de l'identité uniquement. CFMOTO protège vos informations.",
    securityServices: 'Services de sécurité (positionnement en temps réel, clôture électronique, alarme de dysfonctionnement)',
    select: 'Sélectionner',
    selectAccount: 'Sélectionner le compte',
    selectAll: 'Tout sélectionner',
    selectAuthentication: "Sélectionner l'authentification",
    selectChannelType: 'Veuillez sélectionner un canal de commentaires',
    selectCountry: 'Sélectionner le pays',
    selectData: 'Veuillez sélectionner les données que vous souhaitez supprimer, et cliquer sur le bouton Soumettre en bas pour soumettre votre demande de suppression de données.',
    selectDate: 'Sélectionner une date',
    selectEnableStatus: 'Veuillez sélectionner le statut activé',
    selectFeedBackState: 'Sélectionnez le statut de traitement des commentaires',
    selectFeedbackType: 'Veuillez sélectionner un type de réaction',
    selectJumpTarget: 'Veuillez sélectionner la cible de saut',
    selectLanguage: 'Veuillez sélectionner la langue',
    selectOneCarType: 'Sélectionnez au moins un modèle',
    selectPoint: 'Sélectionner un point',
    selectPopupFrequency: 'Veuillez sélectionner la fréquence des pop-ups',
    selectPopupPosition: "Veuillez sélectionner l'emplacement de la fenêtre contextuelle",
    selectPopupTarget: 'Veuillez sélectionner la cible du pop-up',
    selectPopupTime: "Veuillez sélectionner l'heure de la fenêtre contextuelle",
    selectRejectReason: 'Veuillez sélectionner un motif de rejet',
    selectTheLanguage: 'Langue',
    selectTime: 'sélectionner l’heure',
    selectUser: 'Sélectionnez les utilisateurs',
    selectVehicle: 'Sélectionner le véhicule',
    selectedMileage: 'Mile(s) sélectionné(s)',
    selectedMileageRedemption: 'Sélectionner pour consommer le mile',
    selectionOfImporter: "Sélection de l'importateur",
    sendNumberDescription: "nombre d'appareils valides sur lesquels AWS a créé des tâches d'envoi ;",
    sendNumberDescription0: 'Parmi les périphériques cibles effectifs, le serveur Aurora crée en fait avec succès le nombre de périphériques à envoyer des tâches',
    sendNumberVolume: "Nombre d'envois",
    sendTo: 'Envoyer à',
    sendType: "Mode d'envoi",
    sendUserNum: "Nombre d'envois",
    sending: 'En envoyant',
    serial: 'Non.',
    seriesBackground: 'Image de Fond de la Série',
    seriesDesc: 'Description de la série',
    seriesIntroduction: 'Présentation de la série',
    seriesName: 'Nom de la série',
    seriesShowcase: 'Diagramme de présentation de la série',
    seriesUplodImgRule: "Le format d'image requis est jpg/jpeg/png avec un ratio recommandé de 9:16, une résolution de 1080 ou 1920x1080 pixels, et une taille maximale de 5 Mo.",
    seriousAlarm: 'Alarme grave',
    serviceDays: 'Jours de service',
    serviceDetail: 'Détails des services intelligents',
    serviceExpiration: 'Les services intelligents dont vous profitez ont expiré',
    serviceHavExpired: 'Services intelligents expirés',
    serviceIntroduction: 'Introduction au service',
    serviceReset: 'Réinitialisation du service intelligent',
    serviceText: 'Service',
    settingSuccess: 'Réglage effectué avec succès',
    shareNumber: 'Nombre de partages',
    sheet: 'feuille de papier',
    show: 'Voir',
    showPicturesOfVideos: 'Afficher des photos/vidéos',
    showToast1: "Le mile restant n'est pas suffisant à consommer pour un jour de service",
    showToast2: 'Au moins un jour de service est requis pour la consommation',
    showToast3: 'Paramètre inexistant ou nul',
    showroomModel: 'Modèles de showroom',
    showroomModelList: "Liste des modèles de salle d'exposition",
    showroomModelQuery: 'Demande de modèle de showroom',
    showroomUploadRules: "Le format d'image requis est jpg/jpeg/png, le rapport d'image est de 9:19,5, la taille ne dépasse pas 5 Mo et la taille de la vidéo ne dépasse pas 50 Mo.",
    signOut: 'Termination automatique',
    singapore: 'Singapour',
    sixMonths: 'Six mois',
    slideToRight: 'balayez vers la droite',
    smartServices: 'Services intelligents',
    someUser: 'Certains utilisateurs',
    sort: 'Ordre',
    source: 'Source',
    sr_YU: 'serbe',
    standardAgreement: "Statut de l'accord Standard Edition",
    startCalculateTimeBasedata: 'Date de la réinitialisation édition standard',
    startCalculateTimeMotoplay: 'Date de la réinitialisation MotoPlay',
    startChecking: "Commencer l'inspection",
    startTime: 'Heure de début',
    statisticalTime: 'Temps statistique',
    status: 'État',
    stepText1: 'To ensure smooth data migration and use of the CFMOTO RIDESYNC App, we recommend that you follow these steps:',
    stepText2: '1. First, you can click the button below [Download CFMOTO RIDESYNC] or directly open Apple Store/Google Play to search and download CFMOTO RIDESYNC App;',
    stepText3: '2. After downloading and installing, please open the CFMOTO RIDESYNC App to enter the login page. On this page, you need to log in with your existing CFMOTO RIDE account and password;',
    stepText4:
      '3. When you enter your account and password correctly, the App will pop up a prompt window asking whether to start the data migration. When you click OK, the data migration starts immediately and this process is uninterrupted. If you select "Cancel" in this step, you will not be able to continue logging into the App.',
    stepText5: '4. After clicking OK, the data migration will start immediately, and the process is uninterruptable. If that fails, contact it@cfmoto.com',
    stepText6:
      '5. After the data migration is completed, you will automatically enter the vehicle homepage of the CFMOTO RIDESYNC App. At this moment, you can start to use all functions of the App normally, and you will be able to access all the data you previously retained in the CFMOTO RIDE App.',
    stepText7:
      '*Important notes: Be sure to log in the CFMOTO RIDESYNC App with your CFMOTO RIDE account to ensure successful data migration. If you choose to register a new account or log in with another account, your data will not be migrated. In addition, after successful data migration, your original CFMOTO RIDE account will no longer support login to the CFMOTO RIDE App. Please operate carefully to ensure the safe migration of your data.',
    stop: 'Arrêt',
    store: 'Magasin',
    storeAddressCountryTip: "Remarque :  Cette adresse de magasin est le seul moyen pour les utilisateurs de vous trouver.\n  Veuillez remplir avec soin afin de vous assurer que l'adresse est correcte",
    storeAddressDetail: 'Adresse du magasin',
    storeAddressDetailTip: 'Exemple : adresse détaillée : N° 116, Route de Wuzhou, Zone de développement économique de Yuhang, Hangzhou',
    storeAddressPosition: 'Latitude et longitude',
    storeAddressPositionTip:
      'Longitude : la partie entière de la longitude est un nombre entier compris entre -180 et 180, et la partie décimale est une décimale ne dépassant pas 15 chiffres.\nLatitude : la partie entière de la latitude est un nombre entier compris entre -90 et 90, et la partie décimale ne dépasse pas 15 chiffres.',
    storeBusinessType: 'Type de magasin',
    storeImage: 'Image du magasin',
    storeImportTemplateText:
      "Veuillez télécharger le modèle, remplir les informations du magasin du concessionnaire dans le fichier modèle, puis télécharger le fichier ; la taille du fichier est limitée à 1 Mo ; en cas d'échec de la soumission, veuillez réduire le contenu ou télécharger par lots",
    storeIntroduce: 'Présentation du magasin',
    storeList: 'Liste des magasins',
    storeMange: 'Gestion des magasins',
    storeName: 'Nom du magasin',
    storeNameTip: 'Remarque :  Veuillez sélectionner une langue prise en charge par le système pour remplir le nom du magasin',
    storeQueryUserStatistics: 'Statistiques des utilisateurs de recherche de magasin',
    storeRemarkName: 'Nom de la remarque du magasin',
    storeRemarkNameTip: 'Remarque :  Si la langue prise en charge par le système ne répond pas à vos besoins, vous pouvez saisir ici le nom de la remarque du magasin dans la langue de votre choix.',
    storeSearch: 'Requête des magasins',
    storeServicePhone: 'Numéro de téléphone de service',
    storeServicePhoneTip: 'Remarque :  Ce numéro est utilisé pour le contact téléphonique avec les clients, veuillez vous assurer que le numéro de téléphone est correct.',
    storeServiceTime: "Heure d'ouverture",
    storeStatistics: 'Statistiques du magasin',
    storeUploadImageRequire: "Format d'image requis pour jpg/jpeg/png, il est recommandé que la taille d'une seule image ne dépasse pas 5MB, une seule importation jusqu'à 9, peut être importée plus d'une fois, le nombre total ne dépassant pas 9.",
    storefront: 'Magasin',
    submissionFailed: 'Échec de la soumission, veuillez réessayer.',
    submit: 'Soumettre',
    submitAccountDeleteApply: 'Soumettre la demande de suppression de compte',
    submitDataDeleteApply: 'Soumettre la demande de suppression de données',
    submitFeedback: 'Soumettre des commentaires',
    submitForReview: 'Soumettre pour révision',
    submitted: 'Soumis',
    successful: 'effectué avec succès',
    sunday: 'Dimanche',
    supportMapDown: 'Le téléchargement de carte hors ligne est pris en charge',
    supportedChannel: 'Chaînes prises en charge',
    sureAgree: 'Accepter ou non ?',
    sureBackApply: 'Confirmer le retrait de la demande de suppression de compte',
    sureDelete: 'Une fois supprimé, il ne peut pas être récupéré. Es-tu sûr de vouloir le supprimer',
    sureDeleteData: 'Êtes-vous sûr(e) de vouloir supprimer les données sélectionnées ?  Une fois confirmé, les données sont immédiatement supprimées et ne peuvent pas être récupérées',
    sureDeleteSeries: 'Supprimer cette Série ?',
    sureDeleteSetting: 'Êtes-vous sûr de supprimer ce paramètre de paiement',
    sureDeleteStoreInfo: 'Confirmer la suppression des informations relatives à ce magasin ? Après la suppression, les informations ne seront pas récupérables.',
    sureReject: 'Êtes-vous sûr(e) de rejeter ?',
    sureSuspend: "L'envoi s'arrêtera après la résiliation. Etes-vous sûr de vouloir résilier",
    suspend: 'Mettre fin',
    sv_SE: 'suédois',
    switchLanguage: 'Changer la langue',
    system: 'Système',
    systemBusy: 'Le système est occupé, veuillez réessayer plus tard',
    systemVersion: 'version du système',
    tboxInstall: 'Post-installation Tbox',
    tboxIntro: "T-Box est l'appareil clé pour réaliser la fonction de connexion réseau intelligente des véhicules",
    teamConfigTip: 'Nous ouvrirons la fonction Rides (équipe tout-terrain) pour les véhicules répondant aux conditions de configuration ci-dessus. Les frais seront facturés après l’ouverture de la fonction',
    threeMonths: 'Trois mois',
    thursday: 'Jeudi',
    time: 'Temps',
    timeSend: 'Envoi programmé',
    timedOffline: 'Hors ligne programmé',
    timedPush: 'Poussée programmée',
    timedRelease: 'Publication programmée',
    timedSendTime: "Heure d'envoi",
    tips: 'Des astuces',
    title: 'Titre',
    to: 'À',
    toBeReleased: 'À publier',
    topMenu: 'Menu de haut niveau',
    topicContent: 'Contenu du sujet',
    topicList: 'Liste des sujets',
    topicManagement: 'Gestion du sujet',
    topicSearch: 'Recherche du sujet',
    topicTitle: 'Titre du sujet',
    totalAndlLayoutOfStores: 'Nombre total et disposition des magasins',
    totalClicks: 'Nombre total de clics',
    totalNumber: 'Nombre total de fois',
    tr_TR: 'turc',
    triggerNum: 'Nombre de déclencheurs',
    tuesday: 'Mardi',
    turnOn: 'Ouvrir',
    twoCarAndFourCarOfNumber: "Nombre d'utilisateurs de deux-roues et de quatre-roues",
    twoCarOfNumber: "Nombre d'utilisateurs de deux-roues",
    twoWheelConfig: 'Configuration véhicule deux roues adulte',
    twoWheeler: 'Deux-roues',
    twoWheelerAndFourWheeler: 'Deux-roues et quatre-roues',
    twoWheelerMostClicks: 'Modèles à deux roues avec le plus de clics',
    twoWheelowner: 'Propriétaires adultes de deux roues',
    type: 'Type',
    typeMessage: 'type de commentaire',
    types: 'Taper',
    unbind: 'Non lié',
    unbindingCommitment: 'Engagement de déliaison',
    unbindingLabelRealName: 'Nom et prénom',
    unbound: 'Non lié',
    understandRealtimeConditions: "Recevez les vibrations du véhicule et les messages de rappel d'entrée et de sortie du véhicule de la clôture électronique, et comprenez l'état du véhicule en temps réel",
    uninstallTboxDesc: 'Bei Fahrzeugen, die nicht über eine T-Box verfügen, können Sie nach der Bindung grundlegende Fahrzeuginformationen wie Rahmennummer, Motornummer und elektronisches Handbuch anzeigen.',
    unitCurrencyPer: 'Devise unitaire par',
    unitMonth: 'Mois',
    unlimited: 'Illimité',
    unpaid: 'Non payé',
    unprocessed: 'Non traité',
    unresolved: 'Vous ne pouvez toujours pas résoudre ? Cliquez sur',
    unspecified: 'Confidentialité',
    upToTopics: "Jusqu'à %s de sujets peuvent être ajoutés",
    updateAuthenticationTime: "Mettre à jour du temps d'authentification",
    updateBy: 'Mise à jour par',
    updateSuccess: 'Mise à jour terminée',
    updateTime: 'Temps de mise à jour',
    updating: 'mise à jour',
    upgradeAgainDescription: "La tâche de mise à niveau a été repoussée. Veuillez suivre le 【Guide】 en haut de la page actuelle pour connecter le réseau d'affichage TFT à mettre à niveau.",
    upgradeAssistant: 'Aider',
    upgradeDescription: "Lorsqu'une nouvelle version est trouvée, veuillez suivre le 【Guide】 en haut de la page actuelle pour connecter le réseau d'affichage TFT à mettre à niveau.",
    upgradeSuccessful: 'Mise à niveau réussie',
    upgradeType: 'Méthode de mise à jour',
    upload: 'Télécharger',
    uploadDisplayPicture: "Veuillez télécharger l'image d'affichage",
    uploadFail: 'Échec du téléversement',
    uploadFailed: 'Le téléchargement a échoué, veuillez essayer un autre réseau',
    uploadFailedOfTry: 'Le téléchargement a échoué, veuillez réessayer',
    uploadFileMore1M: 'La taille du fichier de téléchargement ne dépasse pas 1M',
    uploadFiles: 'Télécharger le fichier',
    uploadImageRules1To1: "Format d'image requis JPG / JPEG/PNG, échelle d'image 1: 1, taille ne dépassant pas 5mb",
    uploadLog: 'Télécharger le journal',
    uploadPicture: "Téléverser l'image",
    uploadQuantityExceed: 'Le nombre de téléchargements dépasse la limite',
    uploadSuccessful: 'Téléchargement réussi',
    uploadTime: 'Temps de téléchargement',
    uploadTip556_740: "Veuillez télécharger une image d'une largeur et d'une hauteur de 556*740",
    uploadVideoRules: "Seul le téléchargement unique de fichiers vidéo est pris en charge. Il est recommandé que la taille d'une seule vidéo ne dépasse pas 50 Mo.",
    uploadVideoRules4To3: 'Prend en charge le format vidéo, ratio recommandé 4: 3, taille ne dépassant pas 50mb',
    urlLink: 'Lien URL',
    user: 'Utilisateur',
    userAccount: 'Compte utilisateur',
    userEmail: 'E-mail',
    userGender: "Sexe de l'utilisateur",
    userId: 'ID utilisateur',
    userIdTemplate: "Modèle d'importation d'ID utilisateur",
    userIdentity: "ID de l'utilisateur",
    userLocalTime: "Heure de l'utilisateur final",
    userLogin: 'Se Connecter',
    userMobilePhone: 'Téléphone portable',
    userModel: "Modèle d'utilisateur",
    userName: "Nom d'utilisateur",
    userName1: "Nom d'utilisateur",
    userNickname: "Pseudo de l'utilisateur",
    userNum: "Numéro d'utilisateur",
    userPhone: 'Numéro de téléphone mobile',
    userRealName: 'Nom réel',
    userReply: 'Réponse de l’utilisateur en attente',
    userStatus: "Statut de l'utilisateur",
    userType: "Type d'utilisateur",
    userUnbind: "Débridage par l'utilisateur",
    users: 'utilisateurs',
    vacationTime: 'Temps de vacances',
    validNumberVolume: 'Nombre de cibles valides',
    validNumerDescription: "nombre d'appareils restants après le filtrage du groupe cible sélectionné pour la tâche à envoyer ",
    validateAfter24Hours: 'Prise en charge des sélections de dates ultérieures uniquement dans les 24 heures',
    validateEmail: "Le format de l'adresse e-mail est incorrect, veuillez vérifier",
    validateImageRadio: "Exigences en matière de format de fichier d'image : %s, format de l'image : %s, pas plus de %s",
    validateImageSize: "Exigences en matière de format de fichier d'image : %s, taille de l'image recommandée : %s, pas plus de %s",
    validatePhone: 'Erreur de format du numéro de téléphone, veuillez vérifier',
    validateVideo: 'Exigences en matière de format de fichier vidéo : %s, pas plus de %s',
    validateVin: 'Mauvais numéro de VIN, veuillez vérifier.',
    validationCodeError: 'Erreur du code de vérification',
    vechicleFirstBindTime: 'Heure réelle de la première association au véhicule',
    vehicleAlarmDetails: "Détails de l'alarme",
    vehicleBindDuration: 'Durée de liaison du véhicule',
    vehicleBrochure: 'Brochure du véhicule',
    vehicleColor: 'Couleur du véhicule',
    vehicleDetails: 'Détails du véhicule',
    vehicleDrivingLicense: "Certificat d'immatriculation du véhicule",
    vehicleFaultDetails: 'Détails de la faute',
    vehicleGallery: 'Galerie de véhicules',
    vehicleGalleryEntranceConfiguration:
      "La page d'exposition de motos APP et les photos d'entrée de la fonction galerie de véhicules sont toutes prises à partir de la configuration suivante. Veuillez vous assurer que les trois photos sont complétées dans la configuration.",
    vehicleGalleryEntranceSettings: "Paramètres d'entrée de la galerie de véhicules",
    vehicleGalleryUploadRules: "Le format d'image requis est jpg/jpeg/png. Il est recommandé que la taille d’une seule image ne dépasse pas 5 Mo. Un maximum de 10 images peuvent être importées à la fois. Les importations multiples sont autorisées.",
    vehicleIdHomepageImage: "Page principale du certificat d'immatriculation avec le nom du propriétaire et le numéro d'identification du véhicule.",
    vehicleModel: 'Modèle de véhicule',
    vehicleModelAlbum: 'Album modèle',
    vehicleModelCategorySort: 'Trier par catégorie de véhicule',
    vehicleModelDescription: 'Description du modèle',
    vehicleModelList: 'Liste des modèles',
    vehicleModelManagement: 'Gestion des modèles de véhicules',
    vehicleModelName: 'Nom du modèle',
    vehicleModelQuery: 'Requête de modèle de véhicule',
    vehicleModelSeries: 'Série de modèles',
    vehicleModelSorting: 'Tri des modèles',
    vehicleModelType: 'Type de modèle',
    vehicleName: 'Nom du véhicule',
    vehicleNetworkEquipment: 'Dispositif de mise en réseau pour véhicule',
    vehicleOutboundCountry: 'Pays de sortie du véhicule',
    vehicleRemark: 'Remarques',
    vehicleShareInstruction: 'Instructions pour le partage des véhicules',
    vehicleShareInstructionAdd: 'Ajouter un véhicule partager Description',
    vehicleShareInstructionEdit: 'Modifier les instructions de partage de véhicule',
    vehicleType: 'Numéro du moteur',
    vehicleTypeSplicing: "Modèle de retour d'information",
    vehicleUnbindingInstructions: 'Instructions pour demander la déliaison du véhicule',
    verifyCodeSendFail: "Échec de l'envoi du code de vérification",
    verifyCodeSendSuccess: 'Envoi du code de vérification effectué avec succès',
    versionCode: 'Numéro de version',
    versionIntroduction: 'Présentation de la version',
    versionManage: 'Gestion des versions',
    versionManageList: 'Liste de gestion des versions',
    versionMangeTip:
      "Remarque : Il n'est pas permis de créer une version supérieure au numéro de version actuellement publié sur le marché des applications ! Le personnel d'exploitation et de maintenance doit attendre que la dernière version soit publiée sur Google Play ou App Store, puis créer des enregistrements de version correspondant au dernier numéro de version. La création d'enregistrements à l'avance n'est pas autorisée.",
    versionPattern: "Le numéro de version ne peut être saisi que sous forme d'entier compris entre 0 et 999.",
    versionRequired: 'Le numéro de version ne peut pas être vide',
    vhDataBasicService: 'Service de base des données du véhicule',
    video: 'Vidéo',
    videoContent: 'Contenu vidéo',
    videoCover: 'Couverture vidéo',
    videoDetail: 'Détails de la vidéo',
    videoDisplayImages: 'Affichage vidéo',
    videoFile: 'Fichier vidéo',
    videoGuide: 'Configuration du démarrage vidéo',
    videoImageValidate: "Exigences en matière de format de fichier image : png, jpg, jpeg, format d'image 16:9, taille ne dépassant pas 5 Mo.",
    videoList: 'Liste des vidéos',
    videoMaxSizeValidate: 'La taille de la vidéo ne peut pas dépasser 150 Mo',
    videoSizeExceed: 'Veuillez télécharger une vidéo avec une largeur et une hauteur %s',
    viewAllComment: 'Voir tous les commentaires',
    viewCount: 'nombre de visionnages',
    viewCurrentLocation: "Ouvrez l'APP pour voir l'emplacement actuel du véhicule à tout moment",
    viewCurrentLocation2: "Ouvrez l'APP pour afficher l'emplacement actuel du véhicule à tout moment, ce qui est pratique pour trouver des véhicules à courte distance",
    viewDetails: 'Voir les détails',
    viewFeedBackRecords: 'Afficher les enregistrements de commentaires',
    viewLocation: "Ouvrez l'application pour vérifier l'emplacement du véhicule à tout moment",
    viewModel: 'Voir ce modèle',
    viewPush: 'Voir la poussée',
    viewSeries: 'Voir la série',
    viewVehicleInfomation: "Support pour visualiser la piste de conduite quotidienne, le kilométrage, la durée, la vitesse et d'autres informations du véhicule",
    views: 'Vues',
    vin: 'VIN',
    virginia: 'Virginie',
    waitForReview: 'En attente de révision',
    waitUploading: 'Téléchargement, veuillez patienter',
    waitingManualReview: 'En attente de révision manuelle',
    waitingOnline: {},
    waitingPush: 'Attendre',
    wednesday: 'Mercredi',
    whatOTA: "Qu'est-ce qu'OTA ?",
    whyUseNavigation: 'Comment utiliser la navigation',
    whyUseSetting: "Comment définir les paramètres généraux de l'APP",
    withCountry: 'Pays/Région (IP)',
    withInformation: 'Avec des informations',
    withTBOX: 'Avec TBOX',
    withdrawn: 'Retirée',
    withoutCarOfNumber: "Nombre d'utilisateurs sans véhicule",
    withoutTBOX: 'Sans TBOX',
    writeAccountToPass: "Remplir les informations du compte et compléter la vérification d'identité",
    year: 'Année',
    yes: 'Oui',
    youHaveFeedbackMessage: "Vous avez ** des commentaires d'utilisateurs qui n'ont pas été suivis efficacement, veuillez les traiter à temps",
    youthVehicleOwner: 'Jeunes propriétaires de véhicules',
    yoyGrowth: 'Augmentation en glissement annuel',
    zh_CN: 'Chinois',
  },
};
